import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { Banka } from './banka';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-banka-modal-update',
  templateUrl: './banka-modal-update.component.html'
})
export class BankaModalUpdateComponent extends BaseModalUpdateComponent<Banka> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Banka>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
